/**
 * 瓦片地图：用字符画定义，运行时解析成二维数据。
 * 字符表见 TILE_CHARS，可在 data/tiles.js 中扩展。
 */
export class Tilemap {
  /**
   * @param {string[]} rows 字符画
   * @param {Object} chars 字符 -> 瓦片 key
   * @param {Object} tiles 瓦片定义表 { key: {solid, name, ...} }
   * @param {number} tileSize
   */
  constructor({ rows, chars, tiles, tileSize = 40, spawn }) {
    this.tileSize = tileSize;
    this.rows = rows;
    this.h = rows.length;
    this.w = Math.max(...rows.map((r) => r.length));
    this.tiles = tiles;
    this.data = [];
    for (let y = 0; y < this.h; y++) {
      const line = rows[y].padEnd(this.w, ' ');
      const row = [];
      for (let x = 0; x < this.w; x++) {
        const ch = line[x];
        row.push(chars[ch] !== undefined ? chars[ch] : 'void');
      }
      this.data.push(row);
    }
    this.pixelW = this.w * tileSize;
    this.pixelH = this.h * tileSize;
    this.spawn = spawn || { x: (this.w / 2) * tileSize, y: (this.h / 2) * tileSize };
  }

  at(tx, ty) {
    if (tx < 0 || ty < 0 || tx >= this.w || ty >= this.h) return 'void';
    return this.data[ty][tx];
  }

  set(tx, ty, key) {
    if (tx < 0 || ty < 0 || tx >= this.w || ty >= this.h) return;
    this.data[ty][tx] = key;
  }

  /** 该瓦片是否阻挡行走 */
  isSolid(tx, ty) {
    const t = this.tiles[this.at(tx, ty)];
    return !!(t && t.solid);
  }

  isSolidAtPixel(px, py) {
    return this.isSolid(Math.floor(px / this.tileSize), Math.floor(py / this.tileSize));
  }

  tileAtPixel(px, py) {
    return this.at(Math.floor(px / this.tileSize), Math.floor(py / this.tileSize));
  }

  /** 世界像素坐标 -> 瓦片中心 */
  centerOf(tx, ty) {
    return { x: tx * this.tileSize + this.tileSize / 2, y: ty * this.tileSize + this.tileSize / 2 };
  }
}
